import Locales from '../../../common/modules/locales';

const global = window.wrike;

export default class EventsPageModel {
    constructor() {
        this.init();
    }

    init() {
        this.mainUpcomingEvents = global.EventsPage.mainUpcomingEvents || [];
        this.upcomingEvents = global.EventsPage.upcomingEvents || [];
        this.recentEvents = global.EventsPage.recentEvents || [];
        this.user = {
            country: '',
            region: ''
        };

        this.initUser();
    }

    initUser() {
        this.user.country = window.geo ? geo.getCountryCode() : 'US';
        this.user.region = this.getCountryRegion(this.user.country);
    }

    getCountryRegion(country) {
        return Locales.checkEurope(country) ? 'EU' : 'US';
    }

    static getEventTime(event) {
        return new Date(
            event.expiredDate
                .split('.')
                .reverse()
                .join('-')
        ).getTime();
    }

    static isFutureEvent(event) {
        const nowTime = Date.now();
        const eventEndTime = new Date(EventsPageModel.getEventTime(event));
        const hideTime = new Date(eventEndTime.setDate(eventEndTime.getDate() + 1)).getTime();

        return nowTime < hideTime;
    }

    static getFutureEvent(events, event) {
        if (EventsPageModel.isFutureEvent(event)) {
            events.push(event);
        }

        return events;
    }

    checkUpComingEvent(events) {
        this.upcomingEvents = events.reduce(EventsPageModel.getFutureEvent, []);
    }

    getUpcomingEvents(filter) {
        this.checkUpComingEvent(this.upcomingEvents);
        return this.upcomingEvents.filter((event) => {
            if (filter.location === 'All') {
                return !this.isMainEvent(event);
            }

            if (filter.location === 'EU') {
                return Locales.checkEurope(event.country) && !this.isMainEvent(event);
            }

            return filter.location === event.country && !this.isMainEvent(event);
        });
    }

    getRecentEvents(filter) {
        return this.recentEvents.filter((event) => {
            const categoryFilterCondition = filter.category === 'All' ? true : filter.category === event.category;

            if (filter.location === 'All') {
                return categoryFilterCondition;
            }

            if (filter.location === 'EU') {
                return Locales.checkEurope(event.country) && categoryFilterCondition;
            }

            return filter.location === event.country && categoryFilterCondition;
        });
    }

    getMainEvent() {
        return this.mainUpcomingEvents.find((event) => {
            return event.region.toUpperCase() === this.user.region;
        });
    }

    isMainEvent(event) {
        return event.isMainEvent && this.getCountryRegion(event.country) === this.user.region;
    }
}



// WEBPACK FOOTER //
// ./assets/js/projects/events/includes/model.js